<!-- Finder particular de Miscelaneas -->

<template>
  <div class="misc_F" v-if="schema">
    <v-sheet :elevation="4">
      
     <!-- Cabecera -->
      <div class="cabecera" v-if="Entorno.header.header">
        <base_Header 
          :componenteTipo="componenteTipo"
          :Entorno="Entorno.header"
          @onEvent="event_Header">
        </base_Header>
      </div>

      <!-- Contenido -->
      <div class="contenedor"> 

        <!-- Filtro de Busqueda -->
        <div style="display:flex">
          <v-text-field
            v-bind="$input"
            v-model="schema.ctrls.name.value"
            :label="schema.ctrls.name.label"
            @keypress.13="buscarExec('buscarMisc')">                
          </v-text-field>

          <v-btn v-bind="$cfg.btn.busca" @click="buscarExec('buscarMisc')">
            <v-icon dark>{{ $cfg.btn.busca.icono }}</v-icon>
          </v-btn> 
        </div>

        <div style="display:flex">
          <v-select
            v-bind="$select"
            v-model="schema.ctrls.tipo.value"
            :label="schema.ctrls.tipo.label"
            :items="tipo_misc"
            item-value="id"
            item-text="name">                
          </v-select>

          <ctrlfinder finderName="cias_F" :schema="schema.ctrls.cia_id"> </ctrlfinder>
          <ctrlfinder finderName="atlas_F" :schema="schema.ctrls.origen"> </ctrlfinder>
        </div>

        <!-- Grid -->
        <base_Fgrid :padre="stName" :Entorno="Entorno" @onEvent="event_Grid">
          <!-- Slot botonera Top -->
          <template v-slot:top_btns="{ Sitem }">         
            <div style="padding:10px 0 0 10px;">
              <btracombi
                :btra_permisos="schema.btra"
                :btra_particular="Entorno.btra"
                btra_modulo="top"
                @onEvent="event_btra_Top({ accion:$event.accion, row:Sitem })">
              </btracombi>
            </div>
          </template>

          <!-- Slot campo acciones del Grid -->
          <template v-slot:acciones_grid="{ Sitem }">
            <btracombi
              :btra_permisos="schema.btra"
              :btra_particular="Entorno.btra"
              btra_modulo="mrow"
              @onEvent="event_btra_Row({ accion:$event.accion, row:Sitem })">
            </btracombi>
          </template>
        </base_Fgrid>
      </div>

      <!-- Mto como ventana modal -->      
      <v-dialog
        v-model="modal">
          <div class="centrado">             
            <component                 
                :is="component_M"
                :padre="stName"
                :accion="accion"
                :accionRow="accionRow"
                :disparo="disparo"
                @onEvent="event_Mto">
            </component>           
          </div>
      </v-dialog>  

    </v-sheet>
  </div>
</template>



<script>

  import { mixinFinder } from "@/mixins/mixinFinder.js";
  import plugs from "@/common/general_plugs";
  const base_Header = () => plugs.groute("base_Header.vue", "base");
  const base_Fgrid = () => plugs.groute("base_Fgrid.vue", "base");
  const btracombi = () => plugs.groute("btracombi.vue", "comp");
  const ctrlfinder = () => plugs.groute("ctrlfinder.vue", "comp");
  const misc_M = () => plugs.groute("misc_M.vue", "comp");

  export default {
    mixins: [mixinFinder],
    components: { base_Header,  base_Fgrid, btracombi, ctrlfinder, misc_M },
    props: {
      padre: { type:String, default: ''},
      componenteTipo: { type:String, default:'FM' },
      Entorno: { type: Object, default: function() { return JSON.parse(JSON.stringify(this.$cfg.base.F)); }}
    },

    data() {
      return {        
        schema:null,
        api:'misc_F',
        stName:'stFmisc',
        component_M:null,
        modal:false,
        accion:'',
        accionRow: {},        
        disparo:false,

        headers: {}, 
        tipo_misc:[]      
      };
    },

    methods: {
      ini_data() {
        console.log("DEV " + this.api + " ********************** (ini_data)");
        
        // guardo Schema del store en variable local
        this.schema = this.$store.state[this.stName].schema;

        // configuro Entorno 
        this.Entorno.header.titulo = "Miscelaneas";  

        this.headers = {
          header: [
            { text: "Nombre", value: "name", witdh: "10rem" },
            { text: "Tipo", value: "tipo", witdh: "10rem" },
            { text: "Atlas", value: "atlas", witdh: "10rem" },
            { text: "Acciones", value: "acciones", sortable: false, width: "auto" }
          ],
        };

        this.Entorno.grid.headers = this.set_headers();

        // guardo nombre componente de Mto
        if (this.componenteTipo.indexOf('M')>= 0) this.component_M= 'misc_M';

        // items adicionales
        this.tipo_misc= this.$store.state.datos_iniciales.misctipo;
        this.tipo_misc.unshift({ id:"0", name:"(Selecciona Tipo)"});
      }, 


    }
  };
</script>
